<template>
    <div>
        <h4 class="page-header">Users</h4>
        <div class="header">
            <div class="form__group">
                <label class="label--search">Search</label>
                <Search
                    class="input input__round input--search"
                    placeholder="Search..."
                    @on-value-change="searchValueChanged"
                />
            </div>
            <Button class="btn btn__primary" text="New User" @on-click="goToCreatePage"/>
        </div>
        <div class="card">
            <table style="width:100%">
                <tr>
                    <SortItem title="First Name" @set-sort="setSort" sortKey="first_name" :sort="sort"/>
                    <SortItem title="Last Name" @set-sort="setSort" sortKey="last_name" :sort="sort"/>
                    <SortItem title="Client" @set-sort="setSort" sortKey="company_id" :sort="sort"/>
                    <SortItem title="Create At" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
                </tr>
                <tr @click="goToEdit(user.id)" v-for="user in users.data" :key="user.id" class="table-row">
                    <td>{{user.first_name}}</td>
                    <td>{{user.last_name}}</td>
                    <td>{{user.company.name}}</td>
                    <td>{{user.created_at}}</td>
                </tr>
            </table>
        </div>
        <div v-if="users.last_page && (users.last_page > 1)" class="paginate__wrapper">
            <paginate
                :page-count="users.last_page || 1"
                :prev-text="'Prev'"
                :click-handler="onPageChange"
                name="users"
                :next-text="'Next'"
                :first-last-button="true"
                :container-class="'paginate'"
            ></paginate>
        </div>
    </div>
</template>

<script>
    import Search from "../partials/Search.vue";
    import Button from "../partials/Button.vue";
    import Paginate from "vuejs-paginate";
    import SortItem from '../partials/SortItem'
    import * as api from "./api.js";
    import debounce from "lodash/debounce";

    export default {
        name      : "UserList",
        components: {
            Search,
            Paginate,
            Button,
            SortItem
        },
        created   : async function () {
            document.title = ' Users | PayGate Invoice'
            this.fetchUsers();
        },
        methods   : {
            fetchUsers        : async function () {
                this.users = await api.fetchUsers({
                    search: this.search,
                    page  : this.page,
                    sort  : this.sort
                });
            },
            setSort(sort) {
                if (this.sort.value == sort) {
                    if (this.sort.direction == "asc") {
                        this.sort.direction = "desc";
                    } else {
                        this.sort.direction = "asc";
                    }
                } else {
                    this.sort.value = sort;
                    this.sort.direction = "asc";
                }
                this.fetchUsers()
            },
            goToCreatePage() {
                this.$router.push(`users/create`);
            },
            onPageChange      : async function (toPage) {
                this.page = toPage;
                this.fetchUsers({page: this.page});
            },
            goToEdit(id) {
                this.$router.push(`users/${id}`);
            },
            searchValueChanged: async function (search) {
                try {
                    this.users = await api.fetchUsers({page: 1, search: search});
                } catch (e) {
                    this.error = "error";
                }
            }
        },
        data() {
            return {
                page  : 1,
                users : [],
                search: "",
                sort  : {
                    value    : "created_at",
                    direction: "asc"
                }
            };
        }
    };
</script>

<style lang="scss" scoped>
    .button {
        width: 150px;
    }

    .header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .customer-id {
        /*padding-left: 50px;*/
    }
</style>
